import React from 'react';
import { Skeleton, Stack } from '@mui/material';

import {
    CARD_HEIGHT, StyledCardsContainer, StyledCategoryContainer, StyledStackCard,
    StyledStackContainer
} from './styles';

export default function VendorProductsLoading() {
  const renderCard = () => (
    <StyledStackCard>
      <StyledStackContainer height={CARD_HEIGHT} spacing={2}>
        <Stack height={CARD_HEIGHT - 32} width={225}>
          {/* <Skeleton height={16} variant="rectangular" width={64} /> */}
          <Stack height={CARD_HEIGHT} spacing={12} width={200}>
            <Stack spacing={2}>
              <Skeleton height={16} variant="text" width={125} />
              <Stack spacing={0}>
                <Skeleton height={14} variant="text" width={200} />
                <Skeleton height={14} variant="text" width={150} />
              </Stack>
            </Stack>
            <Skeleton height={16} variant="text" width={75} />
          </Stack>
        </Stack>

        <Skeleton height={64} variant="rectangular" width={64} />
      </StyledStackContainer>
    </StyledStackCard>
  );

  return (
    <StyledCategoryContainer loading>
      <Skeleton height={28} variant="text" width={225} />

      <StyledCardsContainer>
        {renderCard()}
        {renderCard()}
        {renderCard()}
        {renderCard()}
      </StyledCardsContainer>
    </StyledCategoryContainer>
  );
}
